import React, { Component } from 'react';
import '../adminDash.css';
import withNavigate from '../../Global_files/WithNavigate';
import { Link } from 'react-router-dom';
import { get, patch, getFreshToken } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import globalVariables from '../../custom_libraries/globalVariables';
import DialogBox from '../DialogBox';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Button from '@mui/material/Button';
import { Switch } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, IconButton } from "@mui/material";
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import CallIcon from '@mui/icons-material/Call';
import PersonIcon from '@mui/icons-material/Person';
import CameraIndoorIcon from '@mui/icons-material/CameraIndoor';
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
    components: {
    MuiCssBaseline: {
      styleOverrides: {

        /* ── Grid ── */
        ".grid-container-user": {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "18px",
          marginTop: "6px",
        },

        /* ── Card ── */
        ".client-card": {
          backgroundColor: '#1d2533',                       // background.paper
          border: '1px solid #5b6e87',
          borderRadius: 2,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          transition: "0.3s",
          '&:hover': { boxShadow: '0 0 10px #225c8b' },
        },

        /* ── Card header ── */
        ".card-header": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          padding: "14px 16px 0",
        },

        /* ── Avatar ── */
        ".card-avatar": {
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "#46586f",
          color: "#b6d8ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "15px",
          fontWeight: 500,
        },

        /* ── Action buttons ── */
        ".card-actions": {
          display: "flex",
          gap: "35px",
        },
        ".icon-btn": {
          width: "30px",
          height: "30px",
          borderRadius: "8px",
          border: "0.5px solid rgba(255,255,255,0.10)",
          background: "transparent",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9ca3af",
          transition: "background 0.12s, border-color 0.12s, color 0.12s",
          "&:hover": {
            background: "rgba(255,255,255,0.06)",
            borderColor: "rgba(255,255,255,0.22)",
            color: "#f9fafb",
          },
          "&.danger:hover": {
            background: "#3b1111",
            borderColor: "#ef4444",
            color: "#f87171",
          },
        },

        /* ── Card body ── */
        ".card-body": {
          padding: "10px 16px 16px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        },
        ".card-name": {
          fontSize: "15px",
          fontWeight: 500,
          color: "#ffffff",                            // text.primary
          margin: 0,
        },
        ".card-divider": {
          height: "0.5px",
          background: "rgba(255,255,255,0.08)",
        },

        /* ── Meta rows ── */
        ".card-meta": {
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        },
        ".meta-row": {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "13px",
        },
        ".meta-label": {
          color: "#bbbbbb",                            // text.secondary
          minWidth: "72px",
          flexShrink: 0,
        },
        ".meta-value": {
          color: "#e5e7eb",
        },

        /* ── Role badges ── */
        ".role-badge": {
          fontSize: "11px",
          fontWeight: 500,
          padding: "2px 8px",
          borderRadius: "20px",
          background: "#1e3a5f",
          color: "#93c5fd",
        },
        ".role-badge.tech": {
          background: "#14532d",
          color: "#86efac",
        },

        /* ── Empty state ── */
        ".empty-state": {
          color: "#fbbf24",
          fontSize: "14px",
        },

      },
    },
  },
});
//------------------------------------------

class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_list: [],
            searchInput: '',
            currentPage: 1,
            rowsPerPage: 15,
            success: false,
            error: false,
            warning: false,
            error1: false,
            success2: false,
            confirmDialog: {
                isOpen: false,
                title: '',
                subtitle: '',
            },
            user_id:'',
            editToggle: false,
            user_name:"",
            first_name: "",
            last_name: "",
            phone_no: "",
            email: "",
            user_passcode: "",
            gasspaging_speaker: "false",
            is_active: true,
            open_progress_bar: false,
            loading: true,
            groups_list: [],
            groupname : '',
            error2: false,
            warning2: false,
            storedLogo: localStorage.getItem("USER_LOGO") || null,
            user_type: "",
            is_technician: false,
            is_client: false,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.validateSignedIn();
          }, 0);
          if (this.state.user_list.length === 0) {
            this.getUsersList();
        }
        // this.getGroupsList(); //uncomment this for group feature in edit user group.
    }

    validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);

          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.warning2 !== prevState.warning2 ||
            this.state.error2 !== prevState.error2 ||
            this.state.error !== prevState.error ||
            this.state.error1 !== prevState.error1 ||
            this.state.success !== prevState.success ||
            this.state.success2 !== prevState.success2
        ) {
            if (
                this.state.warning ||
                this.state.warning2 ||
                this.state.error2 ||
                this.state.error ||
                this.state.error1 ||
                this.state.success ||
                this.state.success2
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        warning2 : false,
                        error2: false,
                        error: false,
                        error1: false,
                        success2: false,
                        success: false,
                    });
                }, 3000); // 1 second
            }
        }
    }

    getGroupsList = async () => {
        try {
        this.startLoading();
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
        }

        const response = await get(urls.GET_ALL_GROUPS, headers);
        this.stopLoading();
        if (!response.data.groups) {
            console.error("Failed to fetch getGroupsList.");
            this.setState({ groups_list: [] });
            return;
        }

        this.setState({ groups_list: response.data.groups});
        } catch (error) {
        console.error("Error in getGroupsList:", error);
        this.setState({ groups_list: [] });
        }
    };

    getUsersList = async () => {
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let dealer_id= localStorage.getItem(globalVariables.USER_ID);

            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            }
        //    let url = urls.GET_USERS_UNDER_ADMIN(dealer_id); //TODO--: Verify the condition to use this API -if technician user logged in show only clients under him.
        //    console.log("--------url---------", url);
            const response = await get(urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id), headers); // API call
            this.setState({ loading: false });
            // Validate the response and extract results
            if (response.error.length > 0) {
                console.error("Invalid response or results:", response);
                this.setState({ user_list: [] });
                return;
            }
            this.setState({ user_list: response.data });
        } catch (error) {
            console.error("Error in getUsersList:", error);
            this.setState({ user_list: [], loading: false, });
        }
    };

    handleDelete = async (email) => {
        // const userConfirmed = window.confirm('Are you sure you want to delete this user?');
        // if (!userConfirmed) return;
        let dealer_id= localStorage.getItem(globalVariables.USER_ID);

        try {
            this.startLoading();
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            const requestBody = JSON.stringify({ email }); // Wrap email in an object
            const response = await fetch(urls.DELETE_USER(dealer_id), {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_tocken}`,
                },
                body: requestBody,
            });
            this.stopLoading();
            if (!response.ok) throw new Error(`Error: ${response.status}`);
                setTimeout(() => {
                    // window.location.reload();
                    this.getUsersList()
                }, 2000);
                this.setState({ selectedBlocks: [], success: true });

        } catch (error) {
            console.error('Error deleting user:', error);
            // alert('Failed to delete client. Please try again.');
            this.setState({ error: true });
        }
    };

    // handleEdit = (user_id) => {
    //     this.props.navigate(`/edit-client/${user_id}`);
    // };

    handleEdit = async (user_id) => {
        this.setState({ editToggle: true, user_id: user_id });
        try {
            this.startLoading();
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.USER_DETAILS(user_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL
            this.stopLoading();
            console.log(`API Response for LoadSelectedUserInfo ${user_id}:`, response);
            let data = response.data[0]

            if (data && Object.keys(data).length > 0) {
                console.log(`API Response for LoadSelectedDeviceInfo ${user_id}:`, data);
                this.setState({
                    user_name: data.username || "",
                    first_name: data.first_name || "",
                    last_name: data.last_name || "",
                    email: data.email || "",
                    phone_no: data.phoneno || "",
                    is_active: data.is_active,
                    user_passcode: data.user_passcode || "",
                    gasspaging_speaker:
                                        data.gasspaging_speaker === true ||
                                        data.gasspaging_speaker === "True",

                    user_type: data.user_type || "",
                    is_technician: data.user_type === "TechnicianUser",
                    is_client: data.user_type === "CustomerUser"
                });

            } else {
                console.error("No valid data returned from the get-camera API");
                // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
    };

    handleEditSave = async () => {
        this.startLoading();
        let { user_name, first_name, last_name, email, phone_no, is_active } = this.state;

        if (
      !this.state.first_name ||
      !this.state.last_name ||
      !this.state.email ||
      !this.state.phone_no ||
      !this.state.user_passcode ||
      !this.state.user_type
    ) {
      this.stopLoading();
      alert("Please fill all the required fields.");
      return;
    }

        // mob no validation
        if (phone_no.length !== 10) {
            this.stopLoading();
            alert("Mobile number must be exactly 10 digits");
            return; // Prevent form submission
        }

        // Email format validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
            this.stopLoading();
            alert("Please enter a valid email address");
            return;
        }


        let data = JSON.stringify({
            user_name,
            first_name,
            last_name,
            email,
            "phoneno": phone_no,
            is_active,
            user_passcode: this.state.user_passcode,
            gasspaging_speaker: this.state.gasspaging_speaker ? "True" : "False",
            user_type: this.state.user_type
        });

        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        //
        let headers = {
            // 'content-type': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${access_tocken}`
        }

        let response = await patch(urls.UPDATE_USER_DEATILS(this.state.user_id), data, headers)
        console.log("response edit user==>", response);
        this.stopLoading();
        if (response && response.data && response.data.length > 0) {
            // alert("Site updated successfully.");
            this.setState({
                success2: true
            })
            setTimeout(() => {
                // window.location.reload();
                this.setState({
                    editToggle: false,
                    });
                this.getUsersList();
            }, 2000);
        } else if (response && response.error[0].email?.includes("user with this email address already exists.")) {
            // alert("User with this email already exists.");
            this.setState({
                warning2: true
            })
        }
         else {
            // alert("Error updating site. Please try again.");
            this.setState({
                error2: true
            })
        }
    }

    closePopup = () => {
        this.setState({ editToggle: false });
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleChangePage = (newPage) => {
        this.setState({ currentPage: newPage });
    };

    handleSearchInputChange = (e) => {
        this.setState({ searchInput: e.target.value,
                        currentPage: 1
         });
      };

    openDialog = (onConfirm) => {
    this.setState({
        confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to delete this User?",
        onConfirm
        },
    });
    };

    closeDialog = () => {
        this.setState({
          confirmDialog: {
            ...this.state.confirmDialog,
            isOpen: false,
          },
        });
      };

    handleToggle = (is_active) => {
             this.setState((prevState) => ({
                is_active: !prevState.is_active, // Toggle the current state
            }));
            console.log("Toggled is_active to:", !this.state.is_active);
    };

    startLoading = () => {
        console.log("startloading")

        this.setState({ open_progress_bar: true })
    };

    stopLoading = () => {
          this.setState({ open_progress_bar: false })
    };

    render() {
        const { user_list, currentPage, rowsPerPage, searchInput ,confirmDialog , success, error, error1, success2, warning,user_type,
            editToggle, user_name, first_name, last_name, email, phone_no,user_passcode, gasspaging_speaker, is_active, loading, groups_list, groupname, warning2, error2} = this.state;

        // Filter user list based on search input
        // const filteredClientList = user_list.filter((user) =>
        //     (user.first_name && user.first_name.toLowerCase().includes(searchInput.toLowerCase())) ||
        //     (user.address && user.address.toLowerCase().includes(searchInput.toLowerCase()))
        // );

        // Filter devices based on search input
        const filteredUserList = user_list.filter((user) =>
        user.username.toLowerCase().includes(searchInput.toLowerCase())
        );

        // Calculate pagination indices
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = filteredUserList.slice(indexOfFirstRow, indexOfLastRow);
        const totalPages = Math.ceil(filteredUserList.length / rowsPerPage);

        // const Stored_user_type = localStorage.getItem(globalVariables.USER_TYPE);

        if (loading) return <p style={{marginLeft:'1cm', color:'#cbcbcb'}}>Loading...</p>;

        return (
            <ThemeProvider theme={darkTheme}>
                <CssBaseline />
                <style>{`
                    @media (max-width: 768px) {
                        .user-list-page {
                            height: auto !important;
                            min-height: 100vh;

                        }

                        .user-list-page .user-list-home {
                            overflow: visible !important;
                            padding-left: 0 !important;
                        }

                        .user-list-page .user-list-content {
                            min-width: 0;
                            margin-left: 40px !important;
                            padding: 5px 5px !important;
                        }

                        .user-list-page .search-container {
                            margin-right: 0;
                        }

                        .user-list-page #search-input {
                            box-sizing: border-box;
                            width: 100%;
                            max-width: 100%;
                        }

                        .user-list-page .grid-container-user {
                            grid-template-columns: minmax(0, 1fr);
                            gap: 12px;
                        }

                        .user-list-page .client-card {
                            min-width: 0;
                        }

                        .user-list-page .card-header,
                        .user-list-page .card-body {
                            padding-left: 12px;
                            padding-right: 12px;
                        }

                        .user-list-page .card-actions {
                            gap: 16px;
                        }

                        .user-list-page .meta-row {
                            min-width: 0;
                            flex-wrap: wrap;
                        }

                        .user-list-page .meta-value {
                            overflow-wrap: anywhere;
                        }

                        .user-list-page .user-list-pagination {
                            flex-wrap: wrap;
                            gap: 8px;
                            margin-top: 32px !important;
                            margin-bottom: 32px !important;
                        }

                        .user-list-page .user-list-edit-overlay {
                            align-items: stretch !important;
                        }

                        .user-list-page .user-list-edit-form {
                            box-sizing: border-box;
                            width: 100%;
                            max-width: 100%;
                            height: 100%;
                            padding: 16px 12px;
                            border-radius: 0;
                            overflow-y: auto;
                            overflow-x: hidden;
                        }

                        .user-list-page .form-group-device-edit {
                            flex-direction: column;
                            align-items: stretch;
                            gap: 6px;
                            margin-bottom: 14px;
                        }

                        .user-list-page .form-group-device-edit label {
                            box-sizing: border-box;
                            width: 100%;
                            margin-right: 0;
                        }

                        .user-list-page .form-group-device-edit > input:not([type="checkbox"]),
                        .user-list-page .form-group-device-edit > select,
                        .user-list-page .form-group-device-edit > div {
                            box-sizing: border-box;
                            width: 100% !important;
                            max-width: 100%;
                        }

                        .user-list-page .form-group-device-edit > div > input:not([type="checkbox"]) {
                            box-sizing: border-box;
                            width: 100% !important;
                            max-width: 100%;
                        }

                        .user-list-page .user-list-active-row {
                            justify-content: space-between;
                            margin-left: 0 !important;
                            gap: 12px !important;
                        }

                        .user-list-page .user-list-active-row .MuiSwitch-root {
                            margin-right: 0 !important;
                        }

                        .user-list-page .user-list-edit-actions {
                            flex-wrap: wrap;
                        }

                        .user-list-page .user-list-edit-actions button {
                            flex: 1 1 120px;
                        }
                    }
                `}</style>
                <div className="user-list-page" style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow:'none' }}>
                    <>
                    <div className="home-container user-list-home" style={{ display: 'flex', flex: '1', overflow: 'hidden', paddingLeft: '5px' }}>
                        <div className="user-list-content" style={{ flex: '5', marginLeft:'15px', padding: '10px' }}>
                        {warning ? (
                        <Alert severity="warning">Please fill all the required fields.</Alert>
                        ) : error ? (
                            <Alert severity="error">Server Error! User was not deleted!</Alert>
                        ) : success ? (
                            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                "User Deleted successful."
                            </Alert>
                        ) : null}
                            <div>
                                <div className="search-container">
                                <span>
                                    {/* <span style={{border: '1px solid gray', width:'25%', padding:'5px'}}> */}
                                    {/* <button style={{backgroundColor:'#5b83ae', color:'white'}}> Excel </button>&nbsp; <button style={{backgroundColor:'#5b83ae', color:'white'}}> PDF </button> */}
                                    </span>
                                    <input
                                    type="text"
                                    id="search-input"
                                    placeholder="Search by user name"
                                    value={searchInput}
                                    onChange={this.handleSearchInputChange}
                                    style={{backgroundColor : "#363c4d", color: "#fff", fontSize:'14px'}}
                                    />
                                </div>
                                {/* <div className="grid-container-user" style={{ marginTop: '6px' }}>
                                { currentRows.length > 0 ?
                                currentRows.map((user) => (
                                    <div key={user.user_id} className="client-card">
                                        <span style={{ display: 'flex', justifyContent: 'right', alignItems:'center' }}>
                                                <Link>
                                                    <img
                                                        width="25"
                                                        height="30"
                                                        src={Editicon}
                                                        id="edit_icon"
                                                        alt="editIcon"
                                                        title='Edit User Info'
                                                        onClick={() => this.handleEdit(user.user_id)}
                                                    />
                                                </Link>&ensp;
                                                <Link>
                                                    <img
                                                        width="20"
                                                        height="18"
                                                        src={Deleteicon}
                                                        id="delete_icon"
                                                        alt="delIcon"
                                                        title='Delete User'
                                                        onClick={() => this.openDialog(() =>this.handleDelete(user.email))}
                                                    />
                                                </Link>
                                        </span>
                                        <div style={{display:'flex', alignItems:'baseline', height:'45px'}}>
                                        <img width="26" height="26" src={Customericon} alt="engineer" />&nbsp;<h3>{user.username || 'N/A'}</h3>
                                        </div>
                                        {user.user_type === "CustomerUser" ?
                                            (
                                                <p><b>Role:</b> {'Customer User'}</p>
                                            ):( user.user_type === "TechnicianUser" ?
                                            (
                                                <p><b>Role:</b> {'Technician User'}</p>
                                            ):("")

                                            )
                                        }
                                        <p><b>Sites assigned:</b> {user.site_count || 0}</p>
                                        <p><b>Phone no.:</b> {user.phoneno || 'N/A'}</p>
                                    </div>
                                ))
                                :(
                                    <p style={{color:'orange'}}>No user is registered.</p>
                                )} EditNoteTwoToneIcon, , , ,

                                </div> */}
                                <div className="grid-container-user" style={{ marginTop: '6px' }}>
  {currentRows.length > 0 ? (
    currentRows.map((user) => {
      const initials = (user.username || 'NA')
        .split(' ')
        .map(w => w[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();

      const roleLabel =
        user.user_type === 'CustomerUser'   ? 'Customer User'   :
        user.user_type === 'TechnicianUser' ? 'Technician User' : null;

      return (
        <div key={user.user_id} className="client-card">

          {/* Header: avatar + actions */}
          <div className="card-header">
            <div className="card-avatar">{initials}</div>
            <div className="card-actions">
              {/* <button
                className="icon-btn"
                title="Edit User Info"
                onClick={() => this.handleEdit(user.user_id)}
              > */}
                <Tooltip
                    title="Edit Device Information"
                    componentsProps={{
                        tooltip: {
                        sx: {
                            backgroundColor: '#283348',
                            color: '#fff',
                            fontSize: '12px',
                            border: '1px solid #99acb8',
                        },
                        },
                        arrow: {
                        sx: {
                            color: '#283348',
                        },
                        },
                    }}
                    >
                    <IconButton
                    size="small"
                    sx={{backgroundColor:'#2e6069', borderRadius: "6px",}}
                    onClick={() => this.handleEdit(user.user_id)}
                    >
                        <Edit fontSize="small" />
                    </IconButton>
                </Tooltip>
              {/* </button> */}
              {/* <button
                className="icon-btn danger"
                title="Delete User"
                onClick={() => this.openDialog(() => this.handleDelete(user.email))}
              > */}
                <Tooltip
                    title="Delete Device"
                    componentsProps={{
                    tooltip: {
                        sx: {
                        backgroundColor: '#283348',
                        color: '#fff',
                        fontSize: '12px',
                        border: '1px solid #99acb8',
                        },
                    },
                    arrow: {
                        sx: {
                        color: '#283348',
                        },
                    },
                    }}
                    >
                    <IconButton
                    size="small"
                    sx={{backgroundColor:'#8c3939', borderRadius: "6px",}}
                    // onClick={() =>
                    //   this.openDialog(() =>
                    //     this.handleDeviceDelete(device.id)
                    //   )
                    // }
                    onClick={() => this.openDialog(() => this.handleDelete(user.email))}
                    >
                    <Delete fontSize="small" />
                    </IconButton>
                </Tooltip>
              {/* </button> */}
            </div>
          </div>

          {/* Body */}
          <div className="card-body">
            <p className="card-name">{user.username || 'N/A'}</p>
            <div className="card-divider" />
            <div className="card-meta">
              {roleLabel && (
                <div className="meta-row">
                  <PersonIcon />
                  {/* <img width="26" height="26" src={Customericon} alt="engineer" /> */}
                  <span className="meta-label">Role</span>
                  <span className={`role-badge${user.user_type === 'TechnicianUser' ? ' tech' : ''}`}>
                    {roleLabel}
                  </span>
                </div>
              )}
              <div className="meta-row">
                <CameraIndoorIcon />
                <span className="meta-label">Sites</span>
                <span className="meta-value">{user.site_count || 0}</span>
              </div>
              <div className="meta-row">
                <CallIcon />
                <span className="meta-label">Phone</span>
                <span className="meta-value">{user.phoneno || 'N/A'}</span>
              </div>
            </div>
          </div>

        </div>
      );
    })
  ) : (
    <p className="empty-state">No user is registered.</p>
  )}
</div>
                                <div className="user-list-pagination" style={{ marginTop: '2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
                                    <Button
                                        id="rowsPerPageButton"
                                        onClick={() => this.handleChangePage(currentPage - 1)}
                                        disabled={currentPage === 1 || totalPages === 0}
                                    >
                                        {"< Prev"}
                                    </Button>&emsp;
                                    <span style={{ fontSize: 'small' }}>
                                        {totalPages === 0
                                            ? "Page 0 / 0"
                                            : `Page ${currentPage} / ${totalPages}`}
                                    </span>&emsp;
                                    <Button
                                        id="rowsPerPageButton"
                                        onClick={() => this.handleChangePage(currentPage + 1)}
                                         disabled={currentPage === totalPages || totalPages === 0}
                                    >
                                        {"Next >"}
                                    </Button>
                                </div>

                            </div>
                        </div>
                    </div>
                    {editToggle && (
                                <div className="user-list-edit-overlay" style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100vh",
                                    backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                                    zIndex: 999,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center", // Align vertically
                                            }}
                                        >

                                        <div className='Slide-device-Add-form user-list-edit-form'>
                                            {/* Close icon */}
                                            <button
                                                onClick={this.closePopup}
                                                style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "10px",
                                                background: "#fff",
                                                border: "none",
                                                fontSize: "18px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                }}
                                            >
                                            ✖
                                            </button>
                                            <div className="form-section">
                                                <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#003366', height: '1cm', alignContent: 'center' }}>Edit User Info</h3>

                                                {error1 ? (
                                                    <Alert severity="error">Server Error! User info was not edited!</Alert>
                                                ) : success2 ? (
                                                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success"> User info was edited successfully!</Alert>
                                                ) : warning2 ? (
                                                    <Alert severity="warning"> User with this email already exists!</Alert>
                                                ) : error2 ? (
                                                    <Alert severity="error"> Error updating the user details!</Alert>
                                                ) : null}

                                                <div className='form-group-device-edit'>
                                                    <label htmlFor="sitename">
                                                        User name : &nbsp;
                                                    </label>
                                                    <input
                                                        readOnly
                                                        type="text"
                                                        name="user_name"
                                                        value={user_name || ""}
                                                        // disabled={Stored_user_type==="DealerUser"}
                                                        onChange={this.handleInputChange}
                                                        style={{ width: "350px", height: "0.7cm", cursor:'default' }}
                                                    />
                                                </div>

                                                <div className='form-group-device-edit'>
                                                    <label htmlFor="sitename">
                                                        First name : &nbsp;
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="first_name"
                                                        value={first_name || ""}
                                                        onChange={this.handleInputChange}
                                                        style={{ width: "350px", height: "0.7cm" }}
                                                    />
                                                </div>

                                                <div className='form-group-device-edit'>
                                                    <label htmlFor="organisation_name">
                                                        Last name: &nbsp;
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="last_name"
                                                        value={last_name || ""}
                                                        onChange={this.handleInputChange}
                                                        style={{ width: "350px", height: "0.7cm" }}
                                                    />
                                                </div>
                                                <div className='form-group-device-edit'>
                                                    <label htmlFor="timezone">
                                                        Phone no. : &nbsp;
                                                    </label>
                                                    <div style={{display:'flex', flexDirection:'column'}}>
                                                        <input
                                                            type="text"
                                                            name="phone_no"
                                                            value={phone_no || ""}
                                                            // onChange={this.handleInputChange}
                                                            onChange={(evt) => {
                                                                const value = evt.target.value.replace(/\D/g, ""); // Only allow numbers
                                                                if (value.length <= 10) {
                                                                this.setState({ phone_no: value });
                                                                }
                                                            }}
                                                            style={{ width: "350px", height: "0.7cm" }}
                                                        />
                                                        {this.state.phone_no.length > 0 && this.state.phone_no.length !== 10 && (
                                                            <p style={{ color: 'red', fontSize:'14px' }}>Mobile number must be exactly 10 digits</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='form-group-device-edit'>
                                                    <label htmlFor="timezone">
                                                        Email : &nbsp;
                                                    </label>

                                                    <input
                                                        type="text"
                                                        name="email"
                                                        value={email || ""}
                                                        onChange={this.handleInputChange}
                                                        style={{ width: "350px", height: "0.7cm" }}
                                                    />

                                                </div>
                                                <div className='form-group-device-edit'>
                                                    <label>
                                                        Operator passkey : &nbsp;
                                                    </label>

                                                    <input
                                                        type="text"
                                                        name="user_passcode"
                                                        value={user_passcode || ""}
                                                        onChange={(e) => {
                                                        const value = e.target.value.replace(/\D/g, "");
                                                        if (value.length <= 8) {
                                                            this.setState({ user_passcode: value });
                                                        }
                                                        }}
                                                        style={{ width: "350px", height: "0.7cm" }}
                                                    />
                                                    </div>
                                                <hr style={{ margin: "25px 0", border: "1px solid #ccc" }} />

                                                <h3 style={{
                                                    color: '#fff',
                                                    textAlign: 'center',
                                                    backgroundColor: '#003366',
                                                    padding: '8px',
                                                    borderRadius: '5px'
                                                }}>
                                                    Edit User Permissions
                                                </h3>
                                                {/* uncomment below div for group feature */}
                                                {/* <div className='form-group-device-edit'>
                                                    <label htmlFor="last_name">
                                                        Group name : &nbsp;
                                                    </label>
                                                    <select
                                                            name="groupname"
                                                            value={groupname}
                                                            onChange={(evt) => this.setState({ groupname: evt.target.value })}
                                                            style={{ width: '365px', height: '1cm', fontFamily: "Arial, sans-serif", fontSize:'13px', color:'black' }}
                                                        >
                                                            <option value="" disabled >Select group for this user</option>
                                                            {groups_list.map((type) => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div> */}
                                               <div className='form-group-device-edit'>
                                                <label>
                                                    User role : &nbsp;
                                                </label>

                                                <div style={{ width: "350px", display: "flex", alignItems: "center", gap: "20px" }}>

                                                    {/* Technician */}
                                                    <div style={{ display: "flex", alignItems: "center" }}>

                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.is_technician || false}
                                                        onChange={() => this.setState({
                                                        is_technician: true,
                                                        is_client: false,
                                                        user_type: "TechnicianUser"
                                                        })}
                                                        style={{ width: "18px", height: "18px", cursor: "pointer", marginRight: "6px" }}
                                                    />

                                                    <span>Technician</span>

                                                    {/* Tooltip Icon */}
                                                    <Tooltip
                                                        className="custom-info-tooltip"
                                                        title={
                                                            <div style={{ width: "320px" }}>
                                                            <strong>Technician Permissions:</strong>
                                                            <br />• Access: System Overview, Sites, Alerts, Analytics
                                                            <br />• Limited to assigned sites only
                                                            <br /><br />

                                                            <strong>System Overview:</strong>
                                                            <br />• View camera stats (Total, Live, Offline)
                                                            <br />• Monitor warnings & errors
                                                            <br />• View logs and last 24h activity
                                                            <br /><br />

                                                            <strong>Sites Tab:</strong>
                                                            <br />• View assigned sites & devices
                                                            <br />• Configure schedules & camera health
                                                            <br />• Cannot add/delete sites
                                                            <br /><br />

                                                            <strong>Alerts Tab:</strong>
                                                            <br />• View and resolve alerts
                                                            <br /><br />

                                                            <strong>Analytics Tab:</strong>
                                                            <br />• View analytics data
                                                            </div>
                                                        }
                                                        arrow
                                                        placement="top"
                                                        componentsProps={{
                                                            tooltip: {
                                                            sx: {
                                                                backgroundColor: '#283348',
                                                                color: '#fff',
                                                                fontSize: '13px',
                                                                border: '1px solid #99acb8',
                                                                padding: '10px'
                                                            },
                                                            },
                                                            arrow: {
                                                            sx: { color: '#283348' },
                                                            },
                                                        }}
                                                        >
                                                        <InfoOutlinedIcon
                                                        style={{
                                                            fontSize: "16px",
                                                            marginLeft: "6px",
                                                            color: "#bac6d6",
                                                            cursor: "pointer"
                                                        }}
                                                        />
                                                    </Tooltip>

                                                    </div>

                                                    {/* Client */}
                                                    <div style={{ display: "flex", alignItems: "center" }}>

                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.is_client || false}
                                                        onChange={() => this.setState({
                                                        is_client: true,
                                                        is_technician: false,
                                                        user_type: "CustomerUser"
                                                        })}
                                                        style={{ width: "18px", height: "18px", cursor: "pointer", marginRight: "6px" }}
                                                    />

                                                    <span>Client</span>

                                                    {/* Tooltip Icon */}
                                                            <Tooltip
                                                            title={
                                                                <div style={{ maxWidth: "350px" }}>
                                                                <strong>Client Permissions:</strong>
                                                                <br />• Access: System Overview, Settings
                                                                <br /><br />

                                                                <strong>System Overview:</strong>
                                                                <br />• View camera stats (Total, Live, Offline)
                                                                <br />• Monitor warnings & errors (Timezone, Offline, HDD)
                                                                <br />• View logs and last 24h activity
                                                                <br />• View device & camera error details
                                                                <br /><br />

                                                                <strong>Settings Tab:</strong>
                                                                <br />• Configure email alerts with scheduling
                                                                <br />• Schedule email delivery timings
                                                                <br />• Select problem types for notifications
                                                                <br />• Access AI Engine settings
                                                                <br />• Create recording templates
                                                                <br /><br />

                                                                <strong>Restrictions:</strong>
                                                                <br />• No access to Sites, Alerts, or Analytics tabs
                                                                <br />• Cannot manage users or permissions
                                                                </div>
                                                            }
                                                            arrow
                                                            placement="top"
                                                            componentsProps={{
                                                                tooltip: {
                                                                sx: {
                                                                    backgroundColor: '#283348',
                                                                    color: '#fff',
                                                                    fontSize: '13px',
                                                                    border: '1px solid #99acb8',
                                                                    maxWidth: 400,        // 🔥 wider
                                                                    maxHeight: 300,       // 🔥 fixed height
                                                                    overflowY: 'auto',    // 🔥 scroll enabled
                                                                    padding: '10px'
                                                                },
                                                                },
                                                                arrow: {
                                                                sx: { color: '#283348' },
                                                                },
                                                            }}
                                                            >
                                                        <InfoOutlinedIcon
                                                        style={{
                                                            fontSize: "16px",
                                                            marginLeft: "6px",
                                                            color: "#bac6d6",
                                                            cursor: "pointer"
                                                        }}
                                                        />
                                                    </Tooltip>

                                                    </div>

                                                </div>
                                                </div>


                                                  <div className='form-group-device-edit'>
                                                <label>
                                                    Allow speaker/mic permission and view business details?: &nbsp;
                                                </label>

                                                <div style={{ width: "350px", display: "flex", alignItems: "center" }}>

                                                    <input
                                                    type="checkbox"
                                                    checked={gasspaging_speaker}
                                                    onChange={(e)=>this.setState({
                                                      gasspaging_speaker:e.target.checked
                                                    })}
                                                    style={{ width: "18px", height: "18px", cursor: "pointer", marginRight:"10px" }}
                                                    />

                                                    <span style={{ display: "flex", alignItems: "center" }}>
                                                    Allow?

                                                    {/* ✅ Tooltip Icon INLINE */}
                                                    <Tooltip
                                                        title="If enabled, the user can use speaker/microphone operation, voice chat features and can view business details in the 'Alert' section. Recommended only for trusted users."
                                                        placement="right"
                                                        arrow
                                                        componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                            backgroundColor: '#283348',
                                                            color: '#fff',
                                                            fontSize: '13px',
                                                            border: '1px solid #99acb8',
                                                            },
                                                        },
                                                        arrow: {
                                                            sx: { color: '#283348' },
                                                        },
                                                        }}
                                                    >
                                                        <InfoOutlinedIcon
                                                        style={{
                                                            fontSize: "18px",
                                                            marginLeft: "6px",
                                                            color: "#bac6d6",
                                                            cursor: "pointer"
                                                        }}
                                                        />
                                                    </Tooltip>

                                                    </span>

                                                </div>
                                                </div>
                                                <div className="user-list-active-row" style={{ display: "flex", marginLeft:'7.5%', gap: "80px", color:"#001668" }}>
                                                    <label htmlFor="timezone">
                                                        Is active? : &nbsp;
                                                    </label>
                                                    <Switch
                                                        checked={is_active}
                                                        onChange={() => this.handleToggle(is_active)}
                                                        name="is_active"
                                                        color="primary"
                                                        size="small"
                                                        style={{marginRight:'18%' }}
                                                    />
                                                </div>
                                                <div className="user-list-edit-actions" style={{ display: "flex", justifyContent: "right", gap: "5px" }}>
                                                    <Button
                                                        type="button"
                                                        onClick={this.handleEditSave}
                                                        style={{
                                                            width: "0.8cm",
                                                            height: "0.7cm",
                                                            // backgroundColor: "#326388",
                                                            // color: "white",
                                                        }}
                                                        id='rowsPerPageButton'
                                                    >
                                                        Save
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={this.closePopup}
                                                        style={{
                                                            width: "0.8cm",
                                                            height: "0.7cm",
                                                            backgroundColor: "#e02e2e",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        )}
                    <DialogBox
                        confirmDialog={confirmDialog}
                        setConfirmDialog={(updatedDialog) =>
                            this.setState({ confirmDialog: updatedDialog })
                        }
                        onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
                        onCancel={this.closeDialog}
                    />
                    </>
                    {/* Backdrop with Circular Progress */}
                    <Backdrop open={this.state.open_progress_bar} style={{zIndex:'1000'}}>
                            <div className="custom-spinner">
                                <div className="circle"></div>
                                <div className="circle tilted"></div>
                                <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                            </div>
                    </Backdrop>
                </div>
            </ThemeProvider>
        );
    }
}

export default withNavigate(UserList);
